import React from 'react';
import _ from 'underscore';
import {
  Circle20Regular,
  Circle20Filled,
  CheckmarkCircle20Regular,
  CheckmarkCircle20Filled,
  Warning20Filled,
} from '@fluentui/react-icons';

export const getDefaultItemIcon = (step) => {
  if (step.hasError || step.containsErrorStep) {
    return <Warning20Filled className="error-icon" />;
  }

  if (step.isSelected || step.containsSelected) {
    return <Circle20Filled className="selected-icon" />; // current step
  }

  if (step.isBehind) {
    return <CheckmarkCircle20Filled className="behind-icon" />;
  }

  if (step.isVisited) {
    return <CheckmarkCircle20Regular className="visited-icon" />; // visited step
  }

  // default
  return <Circle20Regular className="default-icon" />;
};

export const getDefaultItemAriaLabel = (step, i18n) => {
  if (step.isBehind) {
    return i18n.getString(_TL_('Previous step'));
  }
  if (step.isSelected || step.containsSelected) {
    return i18n.getString(_TL_('Current step'));
  }
  return i18n.getString(_TL_('Next step'));
};

export const getAllExpandStepIds = (config) => {
  let stepIds = [];
  _.each(config, (s) => {
    if (!_.isEmpty(s.steps)) {
      stepIds = stepIds.concat(getAllExpandStepIds(s.steps));
    } else {
      stepIds.push(s.id);
    }
  });
  return stepIds;
};

export const parseStepConfig = (config, currentStepId, currentFlow, isSubStep = false) => {
  let stepsConfig = [];
  _.each(config, (s) => {
    const isSelected = s.id === currentStepId;
    const containsSelected = _.some(s.steps, (step) => step.id === currentStepId);
    const containsErrorStep = _.some(s.steps, (step) => step.hasError);
    const isEnabled = currentFlow.includes(s.id) || _.some(s.steps, (step) => currentFlow.includes(step.id));
    const newStepConfig = {
      ...s,
      isEnabled,
      isSubStep,
      isSelected,
      containsSelected,
      containsErrorStep,
    };
    if (!_.isEmpty(s.steps)) {
      const isVisited = isEnabled && _.every(s.steps, (step) => step.isVisited);
      const isBehind = isEnabled && _.every(s.steps, (step) => currentFlow.indexOf(step.id) === -1 || currentFlow.indexOf(step.id) < currentFlow.indexOf(currentStepId));
      const isAhead = isEnabled && _.every(s.steps, (step) => currentFlow.indexOf(step.id) === -1 || currentFlow.indexOf(step.id) > currentFlow.indexOf(currentStepId));
      let subStepsConfig = parseStepConfig(s.steps, currentStepId, currentFlow, true);
      if (isBehind || isAhead) {
        // collapse sub steps if the parent step is behind or ahead
        subStepsConfig = _.map(subStepsConfig, (step) => ({ ...step, isEnabled: false }));
      }
      newStepConfig.steps = subStepsConfig;
      newStepConfig.isBehind = isBehind;
      newStepConfig.isAhead = isAhead;
      newStepConfig.isVisited = isVisited;
      stepsConfig.push(newStepConfig);
      stepsConfig = stepsConfig.concat(subStepsConfig);
    } else {
      const isBehind = isEnabled && currentFlow.indexOf(s.id) < currentFlow.indexOf(currentStepId);
      const isAhead = isEnabled && currentFlow.indexOf(s.id) > currentFlow.indexOf(currentStepId);
      newStepConfig.isBehind = isBehind;
      newStepConfig.isAhead = isAhead;
      stepsConfig.push(newStepConfig);
    }
  });
  return stepsConfig;
};
